import { render } from "./Listsnovipmatch.vue?vue&type=template&id=599c8847&scoped=true"
import script from "./Listsnovipmatch.vue?vue&type=script&lang=js"
export * from "./Listsnovipmatch.vue?vue&type=script&lang=js"

import "./Listsnovipmatch.vue?vue&type=style&index=0&id=599c8847&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599c8847"]])

export default __exports__